import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import axios from "axios";

import Faq from "./Faq";
import FaqTopic from "./FaqTopic";
import FaqSearch from "./FaqSearch";

const API_URL = "https://test.campfr.com/api/get_faqs/";
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function RawHtml({ markup }) {
  return <div dangerouslySetInnerHTML={{ __html: markup }} />;
}


function FaqWrapper() {

  const [allFaqs, setAllFaqs] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(API_URL, { headers: { "X-API-TOKEN": API_TOKEN } });
        console.log("API response: "+data)
        setAllFaqs(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.message || "Failed to fetch workshops");
      } finally {
        setIsLoading(false);
        setError(null); // Clear any previous errors
      }
    })();
  }, []);

  /* -------------------------------------------------- */
  /* 2. filter state                                    */
  /* -------------------------------------------------- */
  const [searchTerm, setSearchTerm] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("all");

  /* -------------------------------------------------- */
  /* 3. apply filters                                   */
  /* -------------------------------------------------- */
  
  const filtered = useMemo(() => {
    return allFaqs.filter((w) => {
      /* search */
      const text = (w.question + " " + w.answer).toLowerCase();
      if (searchTerm && !text.includes(searchTerm.toLowerCase())) return false;

      /* ctype */
      if (subjectFilter !== "all" && w.subject !== subjectFilter) return false;

      return true;
    });
  }, [allFaqs, searchTerm, subjectFilter]);

  return (
    <>
      <div className="faq-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <Faq faqs={filtered} />
            </div>
            <div className="col-lg-4">
              <div className="faq-sidebar">
                <FaqSearch value={searchTerm} onChange={setSearchTerm} />
                <FaqTopic setSubjectFilter={setSubjectFilter} value={subjectFilter} onChange={setSubjectFilter} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FaqWrapper;
